/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentOrganizerDtoSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  avatar: z.string().nullish(),
  description: z.string().nullish(),
  currentUserRole: z.string().nullish(),
  url: z.string().nullish(),
  hasPremiumFeatures: z.optional(z.boolean()),
});
